import React from 'react';

interface TextInputFieldProps {
  id: string;
  name: string;
  type?: 'text' | 'email';
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
}

const TextInputField: React.FC<TextInputFieldProps> = ({
  id,
  name,
  type = 'text',
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  disabled = false,
  required = false,
  className = '',
}) => {
  return (
    <>
      <input
        id={id}
        name={name}
        type={type}
        className={`form-control ${error ? 'is-invalid' : ''} ${className}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        required={required}
      />
      {error && (
        <div className="invalid-feedback invalid-feedback-visible">
          {error}
        </div>
      )}
    </>
  );
};

export default TextInputField;

